import { css, createGlobalStyle } from 'styled-components'

import Reset from 'styles/reset'
import Normalize from 'styles/normalize'

const Global = css`
  html,
  body {
    position: relative;
    font-family: 'Red Rose', sans-serif;
    font-size: 20px;
    line-height: 26px;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.black};
  }

  body {
    overflow: hidden;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 400;

    strong {
      font-weight: 700;
    }
  }

  p {
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
  }

  img {
    margin: 0;
    padding: 0;
  }

  button {
    font-family: 'Red Rose', sans-serif;
  }
`

const GlobalStyles = createGlobalStyle`
  ${Normalize}
    ${Reset}
    ${Global} 
`

export default GlobalStyles
